import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "swingle_portal_token";

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setPortalToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}
export function clearPortalToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const portalApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((cfg) => {
  const t = getPortalToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearPortalToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/portal/login")) {
        window.location.href = "/portal/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function portalLogin(email, password) {
  const { data } = await portalApi.post("/portal/login", { email, password });
  setPortalToken(data.token);
  return data;
}
export async function portalMe() {
  const { data } = await portalApi.get("/portal/me");
  return data;
}
export async function portalAcceptInvite(token, password) {
  const { data } = await portalApi.post("/portal/accept-invite", { token, password });
  setPortalToken(data.token);
  return data;
}
